// @ts-ignore — gdConfig is injected on `window` at build time
declare const gdConfig: any

import Moment from 'moment'
// @ts-ignore — js helper, no .d.ts
import ajaxRequestV2 from '../../api-request/lib/ajax-request-v2'
import {RequestType} from '../../data/types'


// Minimal GraphQL client. POSTs `{query, variables}` to app3's /graphql
// endpoint. Mirrors core/gd/data/request.js for headers and session-id
// plumbing but routes to gdConfig.apiApp3 instead of gdConfig.apiUrl.
//
// Call sites use `.promise()` like any other Request-returned value.
export default class ApiGraphQL {

    static execute(query: string, variables: any = {}) {

        const data: any = {
            query,
            variables,
            // The backend ignores these but the shared session middleware
            // still reads `cid` / `sid` / `zz` off the body to bind the
            // request to a company + user context.
            zz  : Moment().format('ZZ'),
            sid : (window as any).gd?.sessionId,
            cid : (window as any).gd?.companyId,
        }

        const headers: any = {}
        const gd_: any     = (window as any).gd
        if (gd_?.auth?.authMode === 'token') {
            headers['SessionMode']  = 'token'
            headers['SessionToken'] = gd_.auth.authToken
        }
        headers['gd-cid'] = gd_?.companyId

        const endpoint = 'graphql'

        return ajaxRequestV2({
            type     : RequestType.POST,
            endpoint : endpoint,
            url      : gdConfig.apiApp3 + endpoint,
            payload  : data,
            context  : this,
            headers  : headers,
        }, {
            autoError              : true,
            processSessionResponse : true,
        })
    }
}
